import * as React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
// hooks
import { useShowModal } from 'hooks/useShowModal'
import { useDashboardsAPI } from 'hooks/useDashboardsAPI'
// constants
import { Modals } from 'constants/modals'
// views
import {
  Button,
  EditIcon,
  TrashIcon,
  ButtonsWrapper
} from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// store
import { removeWidget, isDashboardEditSelector, Widget } from 'store/reducers/dashboards'

interface Props {
  widget: Widget
}

const ControlButtons: React.FC<Props> = ({ widget }) => {
  const dispatch = useDispatch()

  const isEdit = useSelector(isDashboardEditSelector)

  const { deleteDashboardItem } = useDashboardsAPI()

  const { showModal } = useShowModal({ modalType: Modals.DASHBOARD_WIDGET_SETTINGS_MODAL })

  const { showModal: showDeleteModal } = useShowModal({
    modalType: Modals.CONFIRM_DELETE_WIDGET_MODAL
  })

  const onEditClick = () => {
    showModal({ widget })
  }

  const onDeleteClick = () => {
    showDeleteModal({
      handleConfirm: () => {
        deleteDashboardItem(widget.item.id)
        dispatch(removeWidget(widget.item.id))
      }
    })
  }

  if (!isEdit) {
    return null
  }

  return (
    <ButtonsWrapper>
      <Button onClick={onEditClick}>
        <EditIcon />
      </Button>
      <Button onClick={onDeleteClick}>
        <TrashIcon />
      </Button>
    </ButtonsWrapper>
  )
}
export default ControlButtons
